import BossModel from "@/models/BossModel";
import SendMailContent from '@/models/Dossier/SendMail/SendMailContent/SendMailContent'
import Agent from "@/models/Agent/Agent";
import constants from '@/constants';

export default class SendMail extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'dossier/send-mail';

    /**
     *
     * @type {string}
     */
    static entity = 'sendMails';

    static fields() {
		return {
			id: this.number(null).nullable(),
			dossier_id: this.number(null).nullable(),
			agent_id: this.number(null).nullable(),
			message_cid: this.number(null).nullable(),
			subject: this.attr(null),
			send_status_cid: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			dossier_send_mail_content_id: this.number(null).nullable(),
			send_by_user_id: this.number(null).nullable(),
			created_by_user_id: this.number(null).nullable(),
            agent: this.belongsTo(Agent, 'agent_id'),
		}
	}

    /**
     *
     * @param dossierId
     * @returns {*}
     */
    static byDossier(dossierId) {
        return this.all().filter(item => item.dossier_id === dossierId);
    }

    /**
     *
     * @param dossierId
     * @returns {*}
     */
    static loadByDossier(dossierId) {
        return this.api().where('dossier_id', dossierId)
            .with(['agent'])
            .limit(0)
            .get(true);
    }

    /**
     *
     * @returns {boolean|*}
     */
    Agent() {
        return this.getRelated('agent');
    }

    /**
     *
     * @returns {*}
     */
    Message() {

        const sendMailMessage = constants.sendMailMessages.find(sendMail => sendMail.id === this.message_cid);

        if (!sendMailMessage) {
            throw new Error('Missing SendMail message_cid(' + this.message_cid + ') in constants');
        }

        return sendMailMessage.label;
    }

    /**
     *
     * @returns {string}
     */
    SendStatus() {
        const mailSendStatuses = constants.mailSendStatuses.find(status => status.id === this.send_status_cid);

        if (!mailSendStatuses) {
            throw new Error('Missing SendMail send_status_cid(' + this.send_status_cid + ') in constants');
        }

        return mailSendStatuses.label;
    }

    /**
     *
     * @returns {Promise<unknown>|Promise<AxiosResponse<T>>}
     */
    FetchContent(){
        if (!this.dossier_send_mail_content_id) {
            return new Promise((resolve, reject) => {
                reject('No content linked');
            });
        }

        return SendMailContent.api().find(this.dossier_send_mail_content_id, false).then(response => {
            return response.html;
        });
    }

    /**
     *
     * @returns {boolean}
     */
    IsPending() {
        return constants.mailSendStatuses.find(status => status.key === 'pending').id === this.send_status_cid;
    }

    /**
     *
     * @returns {boolean}
     */
    IsFailed() {
        return constants.mailSendStatuses.find(status => status.key === 'failed').id === this.send_status_cid;
    }

    /**
     *
     * @returns {boolean}
     */
    IsSuccess() {
        return constants.mailSendStatuses.find(status => status.key === 'success').id === this.send_status_cid;
    }
}
